<div mat-dialog-content>
    <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()" cdkFocusInitial>Annuler</button>
</div>

